import { jws, b64utoutf8 } from 'jsrsasign';
import { isSchoolBlocksApp, isSchoolFeedStandalone } from "./SchoolBlocksUtilities";

function getIssuer() {
    if (isSchoolBlocksApp()) {
        return "schoolblocks.com";
    }
    else if (isSchoolFeedStandalone()) {
        return "schoolfeed.org";
    } else {
        return "cleversite.com";
    }
}

export default class JSONWebToken {
    algorithm = 'HS256';
    SB_password = 'school-blocks-key';

    encode(organizationId, url) {
        // Header
        const header = {
            typ: 'JWT',
            alg: this.algorithm,
        };

        // Payload
        const payload = {
            iss: getIssuer(), // issuer
            aud: isSchoolBlocksApp() ? "schoolblocks.com" : "cleversite.com", // audience
            orgid: organizationId,
            returnUrl: url,
        };

        const sHeader = JSON.stringify(header);
        const sPayload = JSON.stringify(payload);
        return jws.JWS.sign("HS256", sHeader, sPayload, this.SB_password);
    }

    decode(jwt) {
        let payloadObj = null;

        const jwtParts = jwt.split(".");
        if (jwtParts.length >= 2) {
            const jwtPayload = jwtParts[1];
            payloadObj = jws.JWS.readSafeJSONString(b64utoutf8(jwtPayload));
        }

        return payloadObj;
    }
}
